import React from 'react';

const STATUS_COLORS = {
    active: { bg: '#e8f5e9', text: '#2e7d32', dot: '#4caf50' },
    leaving: { bg: '#fff3e0', text: '#e65100', dot: '#ff9800' },
    exited: { bg: '#ffebee', text: '#c62828', dot: '#f44336' },
    finished: { bg: '#f3e5f5', text: '#6a1b9a', dot: '#9c27b0' },
    new: { bg: '#e3f2fd', text: '#1565c0', dot: '#2196f3' },
};

function KpiCard({ icon, label, value, sub, color }) {
    return (
        <div
            style={{
                flex: '1 1 160px',
                background: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                padding: 16,
                textAlign: 'center',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 8 }}>
                <span style={{ color: color || '#1976d2', fontSize: 18 }}>{icon}</span>
                <span style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>{label}</span>
            </div>
            <div style={{ fontSize: 28, fontWeight: 700, color: '#333' }}>{value}</div>
            {sub && <div style={{ fontSize: 11, color: '#999', marginTop: 4 }}>{sub}</div>}
        </div>
    );
}

export default KpiCard;
